'use client';

import { FloatingPortal } from '@floating-ui/react';
import { useContext } from 'react';

import { ModalRootContext } from './context/modal-root.context';
import type { ModalPortalPropsInterface } from './types/modal-portal.types';

/**
 * @since 10.0.0
 */
export const ModalPortal = (props: ModalPortalPropsInterface) => {
  const { modal } = useContext(ModalRootContext);

  if (!modal.isMounted) {
    return null;
  }

  return <FloatingPortal {...props} />;
};

ModalPortal.displayName = 'Modal.Portal';
